import React, { useState, useEffect, useRef } from 'react'
import { SERVER_API } from '../../authentication/qlCalls'
import CustomFilter from '../../../components/CustomFilter'
import { convertToDate, convertToTime } from 'src/constants'
import {
  CCard,
  CBadge,
  CCardBody,
  CFormInput,
  CButton,
  CCardTitle,
  CSmartTable,
  CForm,
  CFormLabel,
  CDropdownMenu,
  CDateRangePicker,
  CDropdownItem,
  CRow,
  CCol,
  CCollapse,
  CDropdown,
  CFormSelect,
  CFormCheck,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CAlert,
} from '@coreui/react-pro'
import { parse, format, isValid, parseISO } from 'date-fns'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import './css.css'

const PermissionUser = (props) => {
  const [groupName, setGroupName] = useState('')
  const [groupDetails, setGroupDetails] = useState([])
  const [details, setDetails] = useState([])
  const [startDate, setStartDate] = useState(new Date('2022-01-01'))
  const [endDate, setEndDate] = useState(new Date())
  const [uniqueStatus, setUniqueStatus] = useState([])
  const [filterValue, setFilterValue] = useState('')
  const [uniqueGroup, setUniqueGroup] = useState([])
  const [filterGroup, setFilterGroup] = useState('')
  const [filteredData, setFilteredData] = useState([])

  // Permission modal states
  const [showPermissionModal, setShowPermissionModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [userPermissions, setUserPermissions] = useState({})
  const [loading, setLoading] = useState(false)
  const [saveSuccess, setSaveSuccess] = useState(false)
  const [saveError, setSaveError] = useState('')

  // Dynamic permission matrix states
  const [permissionMatrix, setPermissionMatrix] = useState(null)
  const [loadingMatrix, setLoadingMatrix] = useState(true)

  const columns = [
    {
      key: 'group_name',
      _style: { width: '140px' },
      filter: (column, onFilterChange) => (
        <CustomFilter
          column={column}
          onFilterChange={handleFilterGroupChange}
          uniqueValues={uniqueGroup}
          currentSelected={filterGroup}
        />
      ),
    },
    {
      key: 'username',
      _style: { width: '140px' },
    },
    {
      key: 'userStatus',
      _style: { width: '140px' },
      filter: (column, onFilterChange) => (
        <CustomFilter
          column={column}
          onFilterChange={handleFilterChange}
          uniqueValues={uniqueStatus}
          currentSelected={filterValue}
        />
      ),
    },
    {
      key: 'email',
      _style: { width: '140px' },
    },
    {
      key: 'contact',
      _style: { width: '140px' },
    },
    {
      key: 'leader',
      _style: { width: '140px' },
    },
    {
      key: 'activeRoleName',
      label: 'Role',
      _style: { width: '140px' },
    },
    {
      key: 'datetimeCreated',
      label: 'Date',
      _style: { width: '140px' },
      filter: (values, onChange) => {
        const formatString = 'yyyy/MM/dd'
        return (
          <CDateRangePicker
            footer
            size="sm"
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={(date) => {
              setStartDate(date)
              onChange((item) => {
                if (date) {
                  const parsedDate = parse(item, formatString, new Date())
                  if (isValid(parsedDate)) {
                    return endDate
                      ? parsedDate >= date && parsedDate <= endDate
                      : parsedDate >= date
                  }
                }
                return true
              })
            }}
            onEndDateChange={(date) => {
              setEndDate(date)
              onChange((item) => {
                if (date) {
                  const parsedDate = parse(item, 'yyyy/MM/dd', new Date())
                  if (isValid(parsedDate)) {
                    return startDate
                      ? parsedDate <= date && parsedDate >= startDate
                      : parsedDate <= date
                  }
                }
                return true
              })
            }}
          />
        )
      },
      sorter: (a, b) => {
        const dateA = new Date(a.datetimeCreated).getTime()
        const dateB = new Date(b.datetimeCreated).getTime()
        return dateA - dateB
      },
      _props: { className: 'date-column' },
    },
    {
      key: 'time',
      filter: false,
      _style: { width: '140px' },
    },
    {
      key: 'actions',
      label: 'Actions',
      _style: { width: '100px' },
      filter: false,
      sorter: false,
    },
  ]

  const formatDateTime = (datetime) => {
    const parsedDate = parseISO(datetime)
    const formattedDate = format(parsedDate, 'yyyy/MM/dd')
    const timeString = parsedDate.toLocaleTimeString()
    return { dateString: formattedDate, timeString }
  }

  useEffect(() => {
    const fetchData = async () => {
      await loadPermissionMatrix()
      await handleRetrieveRef()
    }

    if (divRef.current) {
      divRef.current.scrollTop = 0
    }
    fetchData()
  }, [])

  const handleFilterChange = (value) => {
    setFilterValue(value)
  }

  const handleFilterGroupChange = (value) => {
    setFilterGroup(value)
  }

  useEffect(() => {
    if (groupDetails !== null && groupDetails.length > 0) {
      let formattedDetails = groupDetails.map((item) => {
        const { dateString, timeString } = formatDateTime(item.datetimeCreated)
        return { ...item, date: dateString, time: timeString }
      })
      formattedDetails = formattedDetails.filter((item) => item.userStatus !== 'remove')

      if (filterGroup !== '' && filterValue !== '') {
        setFilteredData(
          formattedDetails.filter(
            (item) => item.group_name === filterGroup && item.userStatus === filterValue,
          ),
        )
      } else if (filterGroup !== '') {
        setFilteredData(formattedDetails.filter((item) => item.group_name === filterGroup))
      } else if (filterValue !== '') {
        setFilteredData(formattedDetails.filter((item) => item.userStatus === filterValue))
      } else {
        setFilteredData(formattedDetails)
      }

      if (formattedDetails !== null && formattedDetails.length > 0) {
        const uniqueStatus = [...new Set(formattedDetails.map((item) => item.userStatus))]
        const uniqueGroup = [...new Set(formattedDetails.map((item) => item.group_name))]
        setUniqueGroup(uniqueGroup)
        setUniqueStatus(uniqueStatus)
      }
    }
  }, [filterValue, filterGroup, groupDetails])

  // NEW: Load permission matrix from backend
  const loadPermissionMatrix = async () => {
    setLoadingMatrix(true)
    try {
      var sesKey = localStorage.getItem('sessionKey')

      const query = `query {getpermissionmatrix(sessionToken: \"${sesKey}\") {permissions { name privileges}}}`

      const getBody = (query) => ({
        OperationName: '',
        Query: query,
        Variables: {},
      })

      const response = await fetch(SERVER_API, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(getBody(query)),
      })

      const json = await response.json()

      if (response.ok && json.data.getpermissionmatrix) {
        console.log(json.data)
        setPermissionMatrix(json.data.getpermissionmatrix)
      } else {
        console.error('Failed to load permission matrix')
      }
    } catch (error) {
      console.error('Error loading permission matrix:', error)
    } finally {
      setLoadingMatrix(false)
    }
  }

  // NEW: Helper function to get permission ID by name
  const getPermissionIdByName = (permissionName) => {
    if (!permissionMatrix || !permissionMatrix.permissions) return null

    const index = permissionMatrix.permissions.findIndex(
      (p) => p.name.toLowerCase() === permissionName.toLowerCase(),
    )
    return index !== -1 ? index + 1 : null
  }

  // NEW: Helper function to get privilege ID by name
  const getPrivilegeIdByName = (privilegeName) => {
    const privilegeMap = {
      view: 1,
      create: 2,
      update: 3,
      delete: 4,
      download: 5,
    }
    return privilegeMap[privilegeName.toLowerCase()] || null
  }

  // NEW: Helper function to capitalize first letter
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  const handleRetrieveRef = async () => {
    await getreflist()
  }

  const getreflist = async () => {
    var sesKey = localStorage.getItem('sessionKey')

    const query = `query{getuserlistbygroup(sessionToken:\"${sesKey}\"){ group_name, username, name, email, contact, activeRoleName, userStatus, datetimeCreated, leader}}`

    const getBody = (query, variables) => {
      return {
        OperationName: '',
        Query: query,
        Variables: variables,
      }
    }

    let controller = new AbortController()
    setTimeout(() => controller.abort(), 3000)

    const response = await fetch(
      SERVER_API,
      {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(getBody(query)),
      },
      { signal: controller.signal },
    )

    const json = await response.json()

    if (!response.ok) {
      if (response.status === 400) {
        alert('Invalid session response')
        throw new Error('Invalid session response')
      }
      alert('System error, please login later')
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    if (response.ok) {
      const data = json
      if (data.data.getuserlistbygroup !== null) {
        if (data.data.getuserlistbygroup.length > 0) {
          setGroupDetails(data.data.getuserlistbygroup)
        }
      }
    }
  }

  // Open permission modal and load user permissions
  const handleManagePermissions = async (user) => {
    setSelectedUser(user)
    setShowPermissionModal(true)
    setSaveSuccess(false)
    setSaveError('')
    await loadUserPermissions(user.username) // Changed from userId to username
  }

  // MODIFIED: Load user permissions from backend
  const loadUserPermissions = async (username) => {
    setLoading(true)
    try {
      var sesKey = localStorage.getItem('sessionKey')

      const query = `query {getuserpermissions(sessionToken: \"${sesKey}\", username: \"${username}\") {permission,privilege } }`

      const getBody = (query) => ({
        OperationName: '',
        Query: query,
        Variables: {},
      })

      const response = await fetch(SERVER_API, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(getBody(query)),
      })

      const json = await response.json()

      if (response.ok && json.data.getuserpermissions) {
        // Convert response to checkbox state object
        const permissionsObj = {}
        json.data.getuserpermissions.forEach((perm) => {
          const permissionId = getPermissionIdByName(perm.permission)
          //console.log(permissionId)
          //console.log(perm.privilege)
          if (permissionId) {
            const privilegeId = getPrivilegeIdByName(perm.privilege)
            //console.log(privilegeId)
            if (privilegeId) {
              const key = `${permissionId}_${privilegeId}`
              permissionsObj[key] = true
            }
          }
        })
        setUserPermissions(permissionsObj)
      }
    } catch (error) {
      console.error('Error loading permissions:', error)
      setSaveError('Failed to load permissions')
    } finally {
      setLoading(false)
    }
  }

  // Handle checkbox change
  const handlePermissionChange = (permissionId, privilegeId) => {
    const key = `${permissionId}_${privilegeId}`
    setUserPermissions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }))
  }

  // Check if permission is checked
  const isPermissionChecked = (permissionId, privilegeId) => {
    const key = `${permissionId}_${privilegeId}`
    return userPermissions[key] || false
  }

  // MODIFIED: Save permissions
  const handleSavePermissions = async () => {
    setLoading(true)
    setSaveSuccess(false)
    setSaveError('')

    try {
      var sesKey = localStorage.getItem('sessionKey')

      // Build permissions array with names instead of IDs
      const permissionsArray = []

      if (permissionMatrix && permissionMatrix.permissions) {
        permissionMatrix.permissions.forEach((permission, permIndex) => {
          const permissionId = permIndex + 1
          const selectedPrivileges = []

          permission.privileges.forEach((privilege) => {
            const privilegeId = getPrivilegeIdByName(privilege)
            if (privilegeId && isPermissionChecked(permissionId, privilegeId)) {
              selectedPrivileges.push(privilege)
            }
          })

          if (selectedPrivileges.length > 0) {
            permissionsArray.push({
              permissionName: permission.name,
              privileges: selectedPrivileges,
            })
          }
        })
      }
      const arr = JSON.stringify(permissionsArray).replace(/"([^"]+)":/g, '$1:')
      console.log(arr)
      const mutation = `query {
        updateuserpermissions(
          sessionToken: \"${sesKey}\"
          username: \"${selectedUser.username}\"
          permissions: ${JSON.stringify(arr)}
        ) {
          success
          message
        }
      }`

      const getBody = (query) => ({
        OperationName: '',
        Query: query,
        Variables: {},
      })

      const response = await fetch(SERVER_API, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(getBody(mutation)),
      })

      const json = await response.json()
      console.log(json)
      if (response.ok && json.data.updateuserpermissions.success) {
        setSaveSuccess(true)
        setTimeout(() => {
          setShowPermissionModal(false)
        }, 1500)
      } else {
        setSaveError(json.data.updateuserpermissions.message || 'Failed to save permissions')
      }
    } catch (error) {
      console.error('Error saving permissions:', error)
      setSaveError('Failed to save permissions')
    } finally {
      setLoading(false)
    }
  }

  const getBadge = (status) => {
    switch (status) {
      case 'active':
        return 'success'
      case 'inactive':
        return 'secondary'
      case 'remove':
        return 'danger'
      default:
        return 'primary'
    }
  }

  const divRef = useRef(null)

  return (
    <div className={'overflow'} ref={divRef}>
      <div className={'bigger-table'}>
        <CSmartTable
          clickableRows
          tableProps={{
            striped: true,
            hover: true,
          }}
          activePage={3}
          footer
          columns={columns}
          items={filteredData}
          columnFilter
          tableFilter
          cleaner
          itemsPerPageSelect
          itemsPerPage={20}
          columnSorter
          pagination
          scopedColumns={{
            datetimeCreated: (item) => <td>{convertToDate(item.datetimeCreated)}</td>,
            time: (item) => <td>{convertToTime(item.datetimeCreated)}</td>,
            userStatus: (item) => (
              <td>
                <CBadge color={getBadge(item.userStatus)}>{item.userStatus}</CBadge>
              </td>
            ),
            actions: (item) => (
              <td>
                <CButton
                  color="primary"
                  size="sm"
                  onClick={() => handleManagePermissions(item)}
                  title="Manage Permissions"
                >
                  <CIcon icon={cilPencil} /> Permissions
                </CButton>
              </td>
            ),
          }}
        />
      </div>

      {/* Permission Management Modal */}
      <CModal
        size="xl"
        visible={showPermissionModal}
        onClose={() => setShowPermissionModal(false)}
        backdrop="static"
      >
        <CModalHeader>
          <CModalTitle>Manage Permissions - {selectedUser?.username}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {saveSuccess && (
            <CAlert color="success" dismissible>
              Permissions saved successfully!
            </CAlert>
          )}
          {saveError && (
            <CAlert color="danger" dismissible onClose={() => setSaveError('')}>
              {saveError}
            </CAlert>
          )}

          {selectedUser && (
            <div className="mb-3">
              <CRow>
                <CCol md={4}>
                  <strong>Username:</strong> {selectedUser.username}
                </CCol>
                <CCol md={4}>
                  <strong>Email:</strong> {selectedUser.email}
                </CCol>
                <CCol md={4}>
                  <strong>Role:</strong> {selectedUser.activeRoleName || 'N/A'}
                </CCol>
              </CRow>
              <CRow className="mt-2">
                <CCol md={4}>
                  <strong>Group:</strong> {selectedUser.group_name}
                </CCol>
                <CCol md={4}>
                  <strong>Status:</strong>{' '}
                  <CBadge color={getBadge(selectedUser.userStatus)}>
                    {selectedUser.userStatus}
                  </CBadge>
                </CCol>
              </CRow>
            </div>
          )}

          <hr />

          {loading || loadingMatrix ? (
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : permissionMatrix && permissionMatrix.permissions ? (
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: '200px' }}>Permission</th>
                    {/* Dynamically get unique privileges from the matrix */}
                    {[...new Set(permissionMatrix.permissions.flatMap((p) => p.privileges))].map(
                      (privilege) => (
                        <th key={privilege} className="text-center" style={{ width: '120px' }}>
                          {capitalize(privilege)}
                        </th>
                      ),
                    )}
                  </tr>
                </thead>
                <tbody>
                  {permissionMatrix.permissions.map((permission, permIndex) => {
                    const permissionId = permIndex + 1
                    return (
                      <tr key={permissionId}>
                        <td>
                          <strong>{permission.name}</strong>
                        </td>
                        {/* Render checkboxes only for available privileges */}
                        {[
                          ...new Set(permissionMatrix.permissions.flatMap((p) => p.privileges)),
                        ].map((privilege) => {
                          const privilegeId = getPrivilegeIdByName(privilege)
                          const isAvailable = permission.privileges.includes(privilege)

                          return (
                            <td key={privilege} className="text-center">
                              {isAvailable ? (
                                <CFormCheck
                                  id={`perm_${permissionId}_${privilegeId}`}
                                  checked={isPermissionChecked(permissionId, privilegeId)}
                                  onChange={() => handlePermissionChange(permissionId, privilegeId)}
                                />
                              ) : (
                                <span className="text-muted">-</span>
                              )}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="alert alert-warning">
              Failed to load permission matrix. Please refresh the page.
            </div>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setShowPermissionModal(false)}>
            Cancel
          </CButton>
          <CButton
            color="primary"
            onClick={handleSavePermissions}
            disabled={loading || loadingMatrix}
          >
            {loading ? 'Saving...' : 'Save Permissions'}
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default PermissionUser
